// The emote drawer sorts the emotes of emotes.ts into themes. An entry is the id of a slot (a
// family is listed by its first variant's id, which is also the id of the slot itself). Anything
// not listed here ends up in "Divers" (see buildCategories in index.tsx), so a new emote added to
// emotes.ts shows up without touching this file.

export interface EmoteCategoryDef {
  id: string;
  label: string;
  ids: string[];
}

export const EMOTE_CATEGORIES: EmoteCategoryDef[] = [
  {
    id: 'saluts',
    label: 'Saluts et gestes',
    ids: [
      'IdleWave', 'IdleSalute', 'IdleSilentBow', 'IdleSurrender', 'IdleCivilWarCheer', 'IdleGetAttention',
      'IdleComeThisWay', 'IdleDialogueWelcomeHandGesture', 'IdleSnapToAttention', 'OffsetArmsCrossedStart',
      'IdlePointFar_01', 'IdleApplaudSarcastic', 'SpectatorClap', 'IdleBlowHornImperial', 'IdleBlowHornStormcloak',
      'IdleCO2Ceremony1Welcome', 'IdleCO2Ceremony2Blessing', 'IdleDialogueDefensiveHandGesture',
      'IdleGreybeardWordTeach', 'IdleMagic_01', 'IdleMQ206FelldirShowScroll',
    ],
  },
  {
    id: 'humeurs',
    label: 'Humeurs et réactions',
    ids: [
      'IdleLaugh', 'IdleNervous', 'IdleUncontrollableCough', 'IdleWipeBrow', 'IdleLookFar', 'IdleCowerEnter',
      'IdleInjured', 'IdleSleepNod', 'MT_BreathExhaleShort', 'idle_A_scratch_back', 'IdleCiceroHappy',
      'LooseDialogueResponsePositive', 'LooseDialogueResponseNegative', 'IdleDialogueHandOnChinGesture',
      'IdleDialogueMovingTalkA', 'IdleHandCut', 'IdleMesmerize', 'IdleBracedPain', 'IdleCowering', 'DrunkStart',
      'IdleCannibalFeedStanding', 'IdlePrisonerBeat',
    ],
  },
  {
    id: 'fete',
    label: 'Fête et musique',
    ids: [
      'IdleCiceroDance1', 'IdleCiceroDance2', 'IdleCiceroDance3', 'idledrumstart', 'idlelutestart', 'idleflutestart',
      'IdleMQ201ToastStart', 'idleDrinkingStandingStart', 'IdleDrink', 'idleBarDrinkingStart', 'idleEatingStandingStart',
      'IdleApplaud2', 'IdleDrinkPotion', 'IdleMQ201Drink',
    ],
  },
  {
    id: 'poses',
    label: 'Poses et repos',
    ids: [
      'IdleSitCrossLeggedEnter', 'IdleLayDownEnter', 'IdleKneelingEnter', 'IdleLeanTableEnter', 'IdleWallLeanEnterInstant',
      'IdleWallCornerPeekLEnterInstant', 'IdleWallCornerPeekREnterInstant', 'IdleSitLedgeEnter', 'IdleBarCounterEnter',
      'IdleHandsBehindBack', 'IdleGreybeardMeditateEnter', 'IdleBlessingKneelEnter', 'IdleWarmHandsStanding',
      'IdleWarmHandsCrouched', 'IdleWarmArms', 'IdlestaticposeA', 'IdleGrave_01', 'IdleGrave_02', 'IdleCoffinEnter',
      'IdleBoundKneesEnterInstant', 'IdleExecutioneeIdle', 'IdleAstridEnter', 'IdleWarmHands', 'IdleBoyRitual',
    ],
  },
  {
    id: 'rituels',
    label: 'Rituels et prières',
    ids: ['IdlePray', 'IdleRitualStart', 'IdleRitualSkull1', 'idleRitualSpellStart', 'IdleCO2Ceremony3Chest'],
  },
  {
    id: 'metiers',
    label: 'Gestes de métier',
    ids: [
      'PickUp', 'IdlePickup_Ground', 'IdleStudy', 'IdleExamine', 'IdleTake', 'IdleGive', 'IdleSell', 'IdleMT_DoorBang',
      'IdleWriteLedgerEnter', 'IdleWriteTableStandingEnter', 'IdleNoteRead', 'IdleBook_Reading', 'IdleBook_PageTurn',
      'idleLooseSweepingStart', 'IdleHoe', 'IdleLockPick', 'IdlePullChain', 'IdleScrapeTreeBark', 'IdleCleanSword',
      'IdleCarryBucketFillEnter', 'IdleChiselKneelingEnter', 'IdleChiselStandingEnter', 'IdleHammerTableEnter',
      'IdleHammerWallEnter', 'IdleSearchChestEnter', 'IdleSearchTableEnter', 'IdleStonePickUpEnterInstant',
      'OffsetCarryPotStart', 'OffsetCarryMQ201DrinkTray', 'IdleFeedChicken', 'OffsetFlowerBasketStart',
      'IdleOffsetCarryPotServe', 'IdleLightSconce', 'IdleBook_OnePage', 'IdleBook_Read', 'IdleWriteLedgerWrite',
      'IdleSearchingTable', 'IdleSearchingChest', 'IdleKneeling', 'IdleDwemerExtractorEnter',
      'AO_Cut', 'AO_Tan', 'AO_PickUp', 'AO_PickupLow', 'AO_IdleKnock', 'AO_OpenDoor', 'AO_NoteStart',
    ],
  },
];
